export const dashboardTypes = {
   FETCH_CLINICS: 'FETCH_CLINICS',
   IS_MODAL_OPEN: 'IS_MODAL_OPEN',
   IS_DELETE_INVOICE: 'IS_DELETE_INVOICE'
}